import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "p-mr-2" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Comisión ")
const _hoisted_4 = ["href"]
const _hoisted_5 = {
  key: 0,
  class: "text-gray-800 p-mr-2"
}
const _hoisted_6 = { class: "p-d-flex p-jc-between" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "p-col-3" }, null, -1)
const _hoisted_8 = { class: "p-col-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingScreen = _resolveComponent("LoadingScreen")!
  const _component_ChTag = _resolveComponent("ChTag")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ModuleHeader = _resolveComponent("ModuleHeader")!
  const _component_TabMenu = _resolveComponent("TabMenu")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_LoadingScreen, { key: 0 }))
      : _createCommentVNode("", true),
    (!_ctx.isLoading && !_ctx.errorRef)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_ModuleHeader, null, {
            title: _withCtx(() => [
              _createElementVNode("span", _hoisted_2, [
                _hoisted_3,
                _createElementVNode("a", {
                  href: `https://dash.coderhouse.com/#!/camadas/${_ctx.course.id}`,
                  target: "_blank"
                }, _toDisplayString(_ctx.course.id), 9, _hoisted_4),
                _createTextVNode(" / " + _toDisplayString(_ctx.course.name), 1)
              ]),
              (_ctx.course.finished)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, " Finalizado "))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.course.typeTags, (typeTag, index) => {
                return (_openBlock(), _createBlock(_component_ChTag, {
                  class: _normalizeClass({ 'p-mr-1': index + 1 < _ctx.course.typeTags.length }),
                  key: typeTag
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.Course.convertConfigurationTagToCourseTypeTag(typeTag)), 1)
                  ]),
                  _: 2
                }, 1032, ["class"]))
              }), 128))
            ]),
            "right-content": _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_Button, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.reprocessFeedback(_ctx.course.id.toString()))),
                    class: "p-button-outlined p-ml-4",
                    label: "Reprocesar Feedbacks",
                    loading: _ctx.loading
                  }, null, 8, ["loading"])
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_TabMenu, { model: _ctx.menuItems }, null, 8, ["model"]),
          _createVNode(_component_router_view, null, {
            default: _withCtx(({ Component }) => [
              (_openBlock(), _createBlock(_KeepAlive, null, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                  students: _ctx.students,
                  summaries: _ctx.summaries,
                  course: _ctx.course,
                  syllabus: _ctx.syllabus,
                  staff: _ctx.staff,
                  staffIsLoading: _ctx.staffIsLoading,
                  onLoadStaff: _ctx.onLoadStaff,
                  key: _ctx.$route.fullPath
                }, null, 8, ["students", "summaries", "course", "syllabus", "staff", "staffIsLoading", "onLoadStaff"]))
              ], 1024))
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}